document.addEventListener( 'DOMContentLoaded', () => {
	const accordionContainers = document.querySelectorAll(
		'.accordion-block'
	);

	accordionContainers.forEach( ( accordionContainer ) => {
		const accordions = accordionContainer.querySelectorAll(
			':scope > .accordion-section'
		);

		const type = accordionContainer.dataset.type;

		// Add event listeners to all accordions and toggle them on click
		accordions.forEach( ( accordion ) => {
			const { accordionHeader, accordionContent } =
				accordionParts( accordion );
			accordionHeader.addEventListener( 'click', () =>
				toggleAccordionItem(
					accordionHeader,
					accordionContent,
					accordion,
					accordions,
					type
				)
			);
		} );
	} );
} );

/**
 * Toggle the accordion item
 * @param {HTMLElement} accordionHeader the button that controls the accordion
 * @param {HTMLElement} panel the panel that is controlled by the accordion
 * @param {HTMLElement} accordion the accordion item
 * @param {NodeList} accordions all the accordions in the accordion block
 * @param {String} type the functionment of the block 
 */
function toggleAccordionItem( accordionHeader, panel, accordion, accordions, type ) {
	isAccordionOpen =
		accordionHeader.getAttribute( 'aria-expanded' ) === 'true';
	// Hide every panel only if type = accordion
	if ( !isAccordionOpen && type === "accordion" ) {
		// Hide every panel but the one we want to show
		accordions.forEach( ( accordion ) => {
			const { accordionHeader, accordionContent } =
				accordionParts( accordion );
			if ( accordionContent !== panel ) {
				toggleIsSelected( accordion, 'remove' );
				accordionHeader.setAttribute( 'aria-expanded', 'false' );
				accordionContent.setAttribute( 'aria-hidden', true );
			}
		} );
	}
	toggleIsSelected( accordion, 'toggle' );
	accordionHeader.setAttribute( 'aria-expanded', !isAccordionOpen );
	panel.setAttribute( 'aria-hidden', isAccordionOpen );
}

/**
 * Get the header and content elements of an accordion item
 * @param {HTMLElement} accordion An accordion item
 * @returns an object containing the accordion header and content element
 */
function accordionParts( accordion ) {
	const accordionHeader = accordion.querySelector( '.accordion__trigger' );
	const controlsId = accordionHeader.getAttribute( 'aria-controls' );
	const accordionContent = document.getElementById( controlsId );
	return { accordionHeader, accordionContent };
}

/**
 * Add or remove the is-selected class from an Element
 * @param {HTMLELEMENT} element the element to add or remove the class from
 * @param {string} type accepts "toggle" or "remove"
 */
function toggleIsSelected( element, type ) {
	if ( 'toggle' === type ) {
		element.classList.toggle( 'is-selected' );
	} else {
		element.classList.remove( 'is-selected' );
	}
}